import React from "react";

const Intents = ({ setState, actions }) => {
  const intents = [
    "General Queries",
    "Buy/Renew Policy",
    "Claim",
    "Talk to our agent",
  ];
  return (
    <div>
      {intents.map((intent) => (
        <button
          key={intent}
          onClick={() => actions.handleIntentSelection(intent)}
          className="border border-customBlue hover:bg-gray-100 py-0.5 px-4 my-1 rounded-full w-full"
        >
          {intent}
        </button>
      ))}
    </div>
  );
};

export default Intents;
